import React from 'react';
import { ShieldCheck, ShieldQuestionMark } from 'lucide-react';

function isClaimedListing(listing) {
  const ownershipStatus = String(listing?.ownershipStatus || listing?.claim?.status || '').toLowerCase();
  if (ownershipStatus === 'CLAIMED' || ownershipStatus === 'VERIFIED') return true;

  if (listing?.isClaimed === true || listing?.claimed === true) return true;

  return false;
}

function BasicSidebarClaimedCard({ listing, onClaim }) {
  const isClaimed = isClaimedListing(listing);
  const claimTarget = listing?.slug || listing?.id;
  const publicPath = String(listing?.publicUrl || listing?.publicPath || '').trim();
  const claimHref = publicPath && publicPath.startsWith('/') && !publicPath.startsWith('//')
    ? `${publicPath.replace(/\/$/, '')}/claim`
    : claimTarget ? `/listings/${encodeURIComponent(String(claimTarget))}/claim` : '/claim/new';

  return (
    <section
      id="SidebarClaimedCard"
      className="rounded-lg border p-4"
      style={{
        borderColor: 'var(--border)',
        backgroundColor: 'var(--card)',
        color: '#000',
      }}
    >
      {isClaimed ? (
        <>
          <p className="flex items-center gap-2 text-sm font-semibold text-black">
            <ShieldCheck size={16} className="text-black" />
            Claimed & Verified
          </p>
          <p className="mt-2 text-xs text-black/75">
            This business is verified and actively managed.
          </p>
        </>
      ) : (
        <>
          <p className="flex items-center gap-2 text-sm font-semibold text-black">
            <ShieldQuestionMark size={16} className="text-black" />
            Unclaimed Business
          </p>
          <p className="mt-2 text-xs text-black/70">This business is not yet claimed</p>
          <button
            type="button"
            onClick={onClaim || (() => { window.location.assign(claimHref); })}
            className="mt-3 inline-flex h-9 items-center justify-center rounded-md border px-3 text-sm font-medium text-black transition-colors hover:bg-black hover:text-white"
            style={{ borderColor: 'var(--border)' }}
          >
            Claim This Business
          </button>
        </>
      )}
    </section>
  );
}

export default BasicSidebarClaimedCard;
